import React, { useEffect, useState } from 'react';
import { SubmitButton } from '../components/Buttons';

const LabsForm = ({ data , formTitle}) => {
    
    const [inputLabName, setInputLabName] = useState(null);
    const [inputCountry, setInputCountry] = useState(null);
    const [inputContact, setInputContact] = useState(null);
    const [inputTel, setInputTel] = useState(null);
    const [inputEmail, setInputEmail] = useState(null);
    const [inputState, setInputState] = useState(null);

    useEffect(() => {
        if (data !== null){
            setInputLabName(data["Laboratorio"]);
            setInputCountry(data["País"]);
            setInputContact(data["Contacto"]);
            setInputTel(data["Teléfono"]);
            setInputEmail(data["Correo electrónico"]);
            setInputState(data["Estado"]);
        } 
    },[])

    return (
        <form action="" className='generic-form'>
            <h1>{formTitle} Laboratorio</h1>

            <div className='input-wrapper'>
                <label htmlFor="lab-name" className='input-lbl'>Nombre del Laboratorio</label>
                <input 
                    type="text" 
                    id='lab-name' 
                    className='generic-input'
                    value={ inputLabName }
                    onChange={(e) => inputLabName(e.target.value)}
                />
            </div>
            <div className='input-container'>
                <div className='input-wrapper'>
                    <label htmlFor="country" className='input-lbl'>País</label>
                    <select name="country" id="country" className='generic-input'>
                        {inputCountry && <option value={inputCountry} selected>{inputCountry}</option>} 
                        <option value="">Option 1</option>
                        <option value="">Option 2</option>
                    </select>
                </div>

                <div className='input-wrapper'>
                    <label htmlFor="tel-number" className='input-lbl'>Teléfono</label>
                    <input 
                        type="number" 
                        id='tel-number' 
                        className='generic-input' 
                        value={ inputTel }
                        onChange={(e) => setInputTel(e.target.value)}
                    />
                </div>
            </div>
            
            <div className='input-container'>
                <div className='input-wrapper'>
                    <label htmlFor="contact" className='input-lbl'>Contacto</label>
                    <input 
                        type="text" 
                        id='contact' 
                        className='generic-input'
                        value={ inputContact }
                        onChange={(e) => inputContact(e.target.value)}
                    />
                </div>
                <div className='input-wrapper'>
                    <label htmlFor="email" className='input-lbl'>Correo electrónico</label>
                    <input 
                        type="email" 
                        id='email' 
                        className='generic-input'
                        value={ inputEmail }
                        onChange={(e) => setInputEmail(e.target.value)}
                    />
                </div>
            </div>

            <div className='input-wrapper'>
                <div className='input-lbl'>Estado</div>
                
                <div className='input-radio'>
                    <input 
                        type="radio" 
                        id="active" 
                        name="state" 
                        value="Activo" 
                        checked={inputState==='Activo' ? true : false}
                    />
                    <label for="active">Activo</label>
                </div>
                <div className='input-radio'>
                    <input 
                        type="radio" 
                        id="inactive" 
                        name="state" 
                        value="Inactivo" 
                        checked={inputState==='Inactivo' ? true : false}
                    />
                    <label for="inactive">Inactivo</label>
                </div>
            </div>

            <div className='btn-container'>
                <div className='btn-wrapper'>
                    <SubmitButton text='Guardar'/>
                </div>
            </div>
        </form>

        

    );
}

export default LabsForm;
